import React from 'react';

interface ClearsSectionProps {
  onWeSuccess: () => void;
  onWeFail: () => void;
  onTheySuccess: () => void;
  onTheyFail: () => void;
  actionFeedback?: string | null;
  disabledButtons?: Partial<Record<'weSuccess' | 'weFail' | 'theySuccess' | 'theyFail', boolean>>;
}

const ClearsSection: React.FC<ClearsSectionProps> = ({
  onWeSuccess,
  onWeFail,
  onTheySuccess,
  onTheyFail,
  actionFeedback,
  disabledButtons = {},
}) => (
  <div className="z-10">
    <div className="flex w-full justify-between my-4">
      <div className="w-1/2 text-center text-xl font-bold">We Clear</div>
      <div className="w-1/2 text-center text-xl font-bold">They Clear</div>
    </div>
    <div className="flex w-full gap-6 z-10 px-3">
      <div className="flex-1 items-center flex flex-col gap-5">
        <button
          className={`w-full font-bold rounded-lg py-3 px-3 text-xl md:text-2xl shadow-md transition-all ${
            actionFeedback === 'WE_CLEAR_SUCCESS'
              ? 'bg-[#5cb85c] text-white transform scale-105'
              : 'bg-sd-green text-black'
          } ${disabledButtons.weSuccess ? 'opacity-60 cursor-not-allowed' : ''}`}
          onClick={onWeSuccess}
          disabled={disabledButtons.weSuccess}
        >
          SUCCESS
        </button>
        <button
          className={`w-full font-bold rounded-lg py-3 px-3 text-xl md:text-2xl shadow-md transition-all ${
            actionFeedback === 'WE_CLEAR_FAIL'
              ? 'bg-[#d9534f] text-white transform scale-105'
              : 'bg-sd-green text-black'
          } ${disabledButtons.weFail ? 'opacity-60 cursor-not-allowed' : ''}`}
          onClick={onWeFail}
          disabled={disabledButtons.weFail}
        >
          FAIL
        </button>
      </div>
      <div className="flex-1 items-center flex flex-col gap-5">
        <button
          className={`w-full font-bold rounded-lg py-3 px-3 text-xl md:text-2xl shadow-md transition-all ${
            actionFeedback === 'THEY_CLEAR_SUCCESS' ? 'bg-white text-black' : 'bg-sd-navy text-white'
          } ${disabledButtons.theySuccess ? 'opacity-60 cursor-not-allowed' : ''}`}
          onClick={onTheySuccess}
          disabled={disabledButtons.theySuccess}
        >
          SUCCESS
        </button>
        <button
          className={`w-full font-bold rounded-lg py-3 px-3 text-xl md:text-2xl shadow-md transition-all ${
            actionFeedback === 'THEY_CLEAR_FAIL' ? 'bg-white text-black' : 'bg-sd-navy text-white'
          } ${disabledButtons.theyFail ? 'opacity-60 cursor-not-allowed' : ''}`}
          onClick={onTheyFail}
          disabled={disabledButtons.theyFail}
        >
          FAIL
        </button>
      </div>
    </div>
  </div>
);

export default ClearsSection;
